<template>
  <UiBaseFormVeeBase v-bind="{ ...$props, ...$attrs }">
    <template
      v-for="(_, name) in $slots"
      :key="name"
      #[name]="slotData">
      <slot
        :name="name"
        v-bind="slotData ?? {}" />
    </template>
  </UiBaseFormVeeBase>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'UiBaseFormVee',
  inheritAttrs: false,
  props: {
    refName: { type: String, default: undefined },
    onSubmit: {
      type: Function as PropType<() => Promise<void>>,
      required: true as const,
    },
    resetCallback: {
      type: Function as PropType<() => boolean>,
      default: undefined,
    },
    submitOnEnter: { type: Boolean, default: undefined },
    submitOnCtrlEnter: { type: Boolean, default: undefined },
    errorText: { type: String, default: undefined },
    successText: { type: String, default: undefined },
  },
}
</script>

<style>
@reference "../../globals/css/base.css";

.s-vee-form {
  .s-vee-form-message {
    @apply mt-4 mb-3 rounded p-2;
  }

  .s-vee-error-message {
    @apply bg-error-bg text-error;
  }

  .s-vee-success-message {
    @apply bg-success-bg text-success;
  }

  .s-vee-form-buttons {
    @apply mt-6 flex justify-end gap-2;
  }
}
</style>

